<template>
  <v-dialog
    v-model="showDialog"
    width="500"
    scrollable
    @click:outside="$emit('update:showDialog', false)"
  >
    <v-card max-width="500" style="max-height: 600px" class="rounded-lg">
      <v-card-title class="lighten-2 textDefaultColor justify-center">
        {{ getTitle() }}
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text @scroll="onScroll" class="px-0">
        <div>
          <v-list subheader two-line class="pa-0">
            <div v-for="(item, index) in users" :key="index">
              <user-list-item
                :item="item.User"
                :avatar="item.User.Avatar"
                :fullName="item.User.FullName"
                :department="item.User.Department"
                :userId="item.User.Id"
                :company="item.User.Company"
                :noBg="true"
                :divider="true"
              />
            </div>
          </v-list>
        </div>
        <loading-progress
          :status="loadingList"
          v-if="users.length <= 0 || loadingList"
        />
      </v-card-text> </v-card
  ></v-dialog>
</template>

<script>
import PostService from '../../services/PostService';
import UserListItem from './UserListItem.vue';
import LoadingProgress from '../General/LoadingProgress.vue';

export default {
  data() {
    return {
      users: [],
      loadingList: false,
      page: 1,
      pageSize: 50,
      render: false,
    };
  },
  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
    postId: String,
    listType: {
      type: String,
      default: 'likedUsers',
    },
  },
  mounted() {},
  methods: {
    onScroll(event) {
      const { scrollTop, clientHeight, scrollHeight } = event.target;
      if (!this.render && this.showDialog) {
        if (
          scrollTop + clientHeight + 10 >=
          scrollHeight
        ) {
          this.render = true;
          this.getLikedUsers();
        }
      }
    },
    getUsers() {
      if (this.listType == 'likedUsers') {
        this.getLikedUsers();
      } else if (this.listType == 'viewsUser') {
        this.getViewsUser();
      }
    },

    getTitle() {
      if (this.listType == 'likedUsers') {
        return this.$t('title.likedUsers');
      } else if (this.listType == 'viewsUser') {
        return this.$t('title.viewsUser');
      }
    },

    getLikedUsers() {
      this.loadingList = true;
      PostService.getLikedUsers(this.postId, this.page, this.pageSize)
        .then((res) => {
          if (res.data.length >= this.pageSize) {
            this.render = false;
            this.page++;
          } else {
            this.render = true;
          }
          this.users = [...this.users, ...res.data];
        })
        .catch((err) => {
          console.log(err);
          showError(err);
        })
        .finally(() => {
          this.loadingList = false;
        });
    },

    getViewsUser() {
      console.log('postId :', this.postId);
      this.loadingList = true;
      PostService.getPostViews(this.postId)
        .then((res) => {
          console.log('getPostViews :', res.data);
          this.users = res.data;
        })
        .catch((err) => {
          console.log(err);
          showError(err);
        })
        .then(() => {
          this.loadingList = false;
        });
    },

    clearDialog() {
      this.users = [];
      this.loadingList = false;
      this.page = 1;
      this.render = false;
      console.log(this.$data, 'Clear');
    },
  },
  components: {
    UserListItem,
    LoadingProgress,
  },
  computed: {},
  watch: {
    showDialog(newVal, oldVal) {
      if (newVal == true) {
        this.getUsers();
        //this.getAnswers();
      } else {
        this.clearDialog();
      }
    },
  },
};
</script>
